import { Box, Typography, TypographyProps, styled } from '@mui/material';
import { fontFamily } from 'theme/overrides/fontFamily';

export const StyledPageContainer = styled(Box)(({ theme }) => ({
  height: '100%',

  [theme.breakpoints.down('sm')]: {
    // 63px is our header height
    height: 'calc(100vh - 63px)',
  },
}));

export const StyledHeadline = styled(Typography)<
  TypographyProps<'h1', { component: 'h1' }>
>(() => ({
  wordWrap: 'break-word',
  fontSize: 32,
  fontWeight: 500,
  fontFamily: fontFamily.drukWideMedium,
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  lineHeight: 'normal',
  textOverflow: 'ellipsis',
}));

export const StyledSongDetailsContainer = styled(Box)(({ theme }) => ({
  maxWidth: 1500,
  width: '83%',
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
  borderRadius: theme.spacing(2),
  background: theme.palette.common.black,
  padding: theme.spacing(5),
  boxShadow:
    '0px 11px 24px 0px #0000001A, 0px 44px 44px 0px #00000017, 0px 100px 60px 0px #0000000D, 0px 177px 71px 0px #00000003, 0px 277px 78px 0px #00000000',

  [theme.breakpoints.down('sm')]: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    width: `calc(100% - ${theme.spacing(4)})`,
    marginLeft: 0,
    marginRight: 0,
  },
}));

export const StyledSongDetailsWrapper = styled(Box)(() => ({
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
}));

export const StyledSongActionButtonsRowContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(5),
}));
